(() => {
  const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  function getStatus(date = new Date()) {
    const parts = Object.fromEntries(formatter.formatToParts(date).map(({ type, value }) => [type, value]));
    const minutes = Number(parts.hour) * 60 + Number(parts.minute);
    const weekday = parts.weekday;
    const weekdayOpen = 630;
    const saturdayOpen = 660;
    const close = 1230;
    if (weekday === 'Sun') return ['closed', 'Hızlı teslimat Pazartesi 10:30’da yeniden başlıyor.'];
    if (weekday === 'Sat') {
      if (minutes < saturdayOpen) return ['closed', 'Hızlı teslimat bugün 11:00’de başlıyor.'];
      if (minutes <= close) return ['active', '2 Saatte Teslimat Aktif'];
      return ['closed', 'Hızlı teslimat Pazartesi 10:30’da yeniden başlıyor.'];
    }
    if (minutes < weekdayOpen) return ['closed', 'Hızlı teslimat bugün 10:30’da başlıyor.'];
    if (minutes <= close) return ['active', '2 Saatte Teslimat Aktif'];
    return ['closed', 'Hızlı teslimat yarın 10:30’da yeniden başlıyor.'];
  }
  function updateStatuses() {
    const [state, message] = getStatus();
    document.querySelectorAll('[data-local-delivery-status]').forEach((element) => { element.dataset.state = state; element.textContent = message; });
  }
  document.addEventListener('DOMContentLoaded', updateStatuses);
  document.addEventListener('shopify:section:load', updateStatuses);
  window.PativizyonLocalDelivery = { getStatus };
})();
